import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  StyledTextArea,
  type StyledTextAreaProps,
} from '~/components/elements/StyledTextArea'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export type WhoInputProps = {
  className?: string
  index: number
}

export const WhoInput = ({ className, index }: WhoInputProps) => {
  const { control } = useFormContext<InputValues>()
  const whoField = useFormField(control, `strategies.${index}.who`)
  const { t } = useTranslation()

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<
    EH<StyledTextAreaProps, 'onBlur'>
  >(() => {
    whoField.onBlur()
    logEvent('Edit WHO')
  }, [logEvent, whoField])

  return (
    <LabelingContainer className={className} label={t('who')}>
      <StyledTextArea
        autoSize={true}
        rows={1}
        width="100%"
        {...whoField}
        onBlur={handleBlur}
      />
    </LabelingContainer>
  )
}
